export const greenPrimary = '#016237';
export const greenSecondary = '#b2cfc2';